import { ReactNode } from "react";
import { AlertCircle, CheckCircle } from "lucide-react";

interface NotificationProps {
  type: "success" | "error";
  message: string;
  onClose?: () => void;
  className?: string;
  children?: ReactNode;
}

export default function Notification({ type, message, onClose, className = "", children }: NotificationProps) {
  return (
    <div
      className={`flex items-center px-4 py-2 rounded mb-2 text-sm fade-in border ${
        type === "error"
          ? "bg-red-50 border-red-200 text-red-700"
          : "bg-green-50 border-green-200 text-green-700"
      } ${className}`}
      role="alert"
      style={{ animation: "fadeIn 0.3s" }}
    >
      {type === "error" ? (
        <AlertCircle className="w-4 h-4 mr-2" />
      ) : (
        <CheckCircle className="w-4 h-4 mr-2" />
      )}
      <span className="flex-1">{message}</span>
      {children}
      {onClose && (
        <button
          onClick={onClose}
          className="ml-2 text-lg font-bold text-gray-400 hover:text-gray-600 focus:outline-none"
          aria-label="Dismiss message"
          tabIndex={0}
        >
          ×
        </button>
      )}
      <style jsx global>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
} 